import { FC, useState, memo } from 'react';

const Footer: FC = () => {
    const [currentYear, ] = useState((new Date()).getFullYear());
    
    return (
        <footer>
            <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 bg-white">
                <div className="flex items-center justify-between h-16">
                    <div className="flex items-center">
                        <div className="flex-shrink-0">
                            © {currentYear} Ready311
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default memo(Footer);